'use client';

import { useDraw } from '@svs/nova-poolbetting/core/frameworks/nextjs/draw';
import type { DrawNumber } from '@svs/nova-poolbetting/schema/draw';
import type { Definition } from '@svs/nova-poolbetting/schema/frameworks';
import type { EventNumber } from '@svs/nova-poolbetting/schema/sport';
import type { PropsWithChildren, ReactNode } from 'react';

import CouponRowWrapper from './CouponRowWrapper';

type CouponRowWrapperProps = PropsWithChildren & {
  eventNumber: EventNumber;
  product: Definition['drawProducts'][number];
  drawNumber: DrawNumber;
};

/**
 * Wrapper component for coupon rows.
 *
 * @param root0 props for coupon row wrapper
 * @param root0.children React children elements
 * @param root0.eventNumber event number for coupon row
 * @param root0.product product module engine
 * @param root0.drawNumber draw number for coupon row
 * @returns Coupon row child components
 */
export default function CouponRowWrapperContainer({
  children,
  eventNumber,
  product,
  drawNumber,
}: CouponRowWrapperProps): ReactNode {
  const drawResults = useDraw({ product, drawNumber });

  // No need to animate if results is of type result (draw finished);
  if (drawResults.isError || drawResults.data.draw.drawState.client !== 'Live') {
    return children;
  }

  return (
    <CouponRowWrapper eventNumber={eventNumber} drawNumber={drawNumber} product={product}>
      {children}
    </CouponRowWrapper>
  );
}
